import { render } from "./CampaignTable.vue?vue&type=template&id=70b79392&scoped=true"
import script from "./CampaignTable.vue?vue&type=script&lang=js"
export * from "./CampaignTable.vue?vue&type=script&lang=js"

import "./CampaignTable.vue?vue&type=style&index=0&id=70b79392&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70b79392"]])

export default __exports__